// Display helpers for the Product Master screens (list page + add / edit modals).
// Presentation only - nothing here touches form state or API payloads.
import React from "react";

// Two-letter tile text from a product name: "Almarai Fresh Milk" -> "AF".
export const pmInitials = (name) => {
  const words = String(name || "")
    .replace(/[^\p{L}\p{N} ]/gu, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return "—";
  const first = words[0];
  const second = words[1] ? words[1][0] : first[1] || "";
  return (first[0] + second).toUpperCase();
};

// Stable hue (0-359) from any key, so a category always gets the same colour.
export const pmHue = (key) => {
  const s = String(key || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return s ? h % 360 : 228;
};

// ---- icons that feather does not ship ----
export const PmTranslateIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M1.8 3.4h6.4M5 1.8v1.6M6.6 3.4c0 3-2 5.2-4.8 6.2M3.4 6.2c.9 1.9 2.6 3.2 4.6 3.8" />
    <path d="M8.6 14.2l3-7.4 3 7.4M9.7 11.6h3.8" />
  </svg>
);

export const PmBarcodeIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M2 4V2.6h1.6M14 4V2.6h-1.6M2 12v1.4h1.6M14 12v1.4h-1.6" />
    <path d="M5 5v6M7 5v6M9.2 5v6M11.4 5v6" />
  </svg>
);

export const PmImageIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="8.5" cy="9.5" r="1.6" />
    <path d="M3 16.5 8.5 12l4 3.5L16 13l5 4.5" />
  </svg>
);

export const PmGalleryIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M8 4v16M16 4v16" />
  </svg>
);
